(function () {
  function initCardVideos(scope) {
    var root = scope || document;
    root.querySelectorAll('.ha-card__media video').forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function revealOnScroll(root, scope) {
    // Cards are visible by default in CSS; keep this as a no-op-safe helper
    // for any future motion that must not hide content.
    var context = scope || root;
    if (!context) return;
    context.querySelectorAll('.ha-card, .ha-featured, .ha-break').forEach(function (el) {
      el.classList.add('is-visible');
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  function parallaxHero(root) {
    var titles = root && root.querySelector('.ha-hero__titles');
    if (!titles) return;

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var y = Math.min(window.scrollY, 420);
          titles.style.transform = 'translate3d(0,' + y * 0.18 + 'px,0)';
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  function cleanNextUrl(href) {
    if (!href) return '';
    try {
      var url = new URL(href, window.location.origin);
      url.searchParams.delete('phcursor');
      url.searchParams.delete('sections');
      url.searchParams.delete('section_id');
      return url.pathname + url.search;
    } catch (e) {
      return href;
    }
  }

  function initInfiniteScroll(root) {
    var grid = root.querySelector('[data-ha-grid]');
    var pagination = root.querySelector('[data-ha-pagination]');
    if (!grid || !pagination) return;

    var nextLink = pagination.querySelector('[data-ha-next]');
    var sentinel = pagination.querySelector('[data-ha-sentinel]');
    var spinner = pagination.querySelector('[data-ha-spinner]');
    if (!nextLink || !sentinel) return;

    pagination.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    var sectionId = root.getAttribute('data-section-id');
    var loading = false;
    var nextUrl = cleanNextUrl(nextLink.getAttribute('href'));
    var observer = null;

    function setLoading(isLoading) {
      loading = isLoading;
      if (!spinner) return;
      if (isLoading) spinner.removeAttribute('hidden');
      else spinner.setAttribute('hidden', '');
    }

    function finish() {
      nextUrl = '';
      pagination.setAttribute('hidden', '');
      if (observer) observer.disconnect();
    }

    function extract(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return {
        grid: doc.querySelector('[data-ha-grid]'),
        next: doc.querySelector('[data-ha-next]')
      };
    }

    function appendItems(sourceGrid) {
      var count = 0;
      Array.prototype.forEach.call(sourceGrid.children, function (child) {
        if (
          !child.classList ||
          !(child.classList.contains('ha-card') || child.classList.contains('ha-break'))
        ) {
          return;
        }
        var node = child.cloneNode(true);
        node.classList.add('is-visible');
        node.setAttribute('data-ha-loaded', 'true');
        node.style.opacity = '1';
        node.style.transform = 'none';
        // Nested cards inside inframezzi must stay visible too
        node.querySelectorAll('.ha-card').forEach(function (nested) {
          nested.classList.add('is-visible');
          nested.setAttribute('data-ha-loaded', 'true');
          nested.style.opacity = '1';
          nested.style.transform = 'none';
        });
        grid.appendChild(node);
        count += 1;
      });
      initCardVideos(grid);
      return count;
    }

    function requestNextHtml() {
      var pageUrl = cleanNextUrl(nextUrl);
      if (!pageUrl) return Promise.reject(new Error('No next url'));

      // Prefer Section Rendering API (smaller payload), fall back to full page HTML
      if (sectionId) {
        var sectionUrl = new URL(pageUrl, window.location.origin);
        sectionUrl.searchParams.set('sections', sectionId);
        return fetch(sectionUrl.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        }).then(function (res) {
          if (!res.ok) throw new Error('Section request failed');
          return res.json().then(function (data) {
            var html = (data && data[sectionId]) || '';
            if (!html) {
              var keys = Object.keys(data || {});
              html = keys.length ? data[keys[0]] : '';
            }
            if (!html) throw new Error('Empty section');
            return html;
          });
        }).catch(function () {
          return fetch(pageUrl, { credentials: 'same-origin' }).then(function (res) {
            if (!res.ok) throw new Error('Page request failed');
            return res.text();
          });
        });
      }

      return fetch(pageUrl, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('Page request failed');
        return res.text();
      });
    }

    function loadNext() {
      if (loading || !nextUrl) return;
      setLoading(true);

      requestNextHtml()
        .then(function (html) {
          var parsed = extract(html);
          if (!parsed.grid) throw new Error('Missing grid');
          var count = appendItems(parsed.grid);
          if (!count) throw new Error('No items');

          if (parsed.next && parsed.next.getAttribute('href')) {
            nextUrl = cleanNextUrl(parsed.next.getAttribute('href'));
            nextLink.setAttribute('href', nextUrl);
          } else {
            finish();
          }
        })
        .catch(function () {
          finish();
        })
        .finally(function () {
          setLoading(false);
        });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext();
          });
        },
        { rootMargin: '800px 0px', threshold: 0 }
      );
      observer.observe(sentinel);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          if (!nextUrl || loading) return;
          var rect = sentinel.getBoundingClientRect();
          if (rect.top < window.innerHeight + 800) loadNext();
        },
        { passive: true }
      );
    }
  }

  function initCollection() {
    var root = document.querySelector('[data-ha-collection]');
    if (!root) return;
    document.documentElement.setAttribute('data-ha-plp', 'true');
    revealOnScroll(root);
    initCardVideos(root);
    parallaxHero(root);
    initInfiniteScroll(root);
  }

  function initCarousel() {
    var track = document.querySelector('[data-ha-carousel-track]');
    if (!track) return;

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });

    // ——— Continuous auto-scroll (marquee, infinite loop) ———
    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var originals = Array.prototype.slice.call(track.children);
    if (reduce || originals.length < 2 || track.scrollWidth <= track.clientWidth + 4) {
      return;
    }

    // Clone the strip once so scrollLeft can wrap without a visible seam.
    originals.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.classList.add('is-clone');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    track.querySelectorAll('.is-clone video').forEach(function (v) {
      v.muted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    });
    track.classList.add('is-marquee');

    var lapWidth = 0;
    var speed = 40;
    function measure() {
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      lapWidth = 0;
      originals.forEach(function (s) {
        lapWidth += s.getBoundingClientRect().width + gap;
      });
      var firstW = originals[0].getBoundingClientRect().width || 400;
      speed = firstW / 5.5; // px per second ≈ one slide every ~5.5s
      if (track.scrollLeft >= lapWidth) track.scrollLeft = track.scrollLeft % lapWidth;
    }
    measure();

    var hovering = false;
    var touching = false;
    var last = 0;
    track.addEventListener('mouseenter', function () { hovering = true; });
    track.addEventListener('mouseleave', function () { hovering = false; });
    track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    track.addEventListener('touchend', function () {
      setTimeout(function () { touching = false; }, 1200);
    }, { passive: true });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 200);
    });

    function tick(now) {
      var dt = last ? now - last : 0;
      last = now;
      if (dt > 0 && dt < 100 && !hovering && !touching && !isDown && !document.hidden) {
        track.scrollLeft += speed * (dt / 1000);
        if (track.scrollLeft >= lapWidth) track.scrollLeft -= lapWidth;
        else if (track.scrollLeft <= 0) track.scrollLeft += lapWidth;
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initProductUi() {
    var desc = document.querySelector('[data-ha-desc]');
    var more = document.querySelector('[data-ha-more-info]');
    if (desc && more) {
      var evaluate = function () {
        if (desc.classList.contains('is-expanded')) return;
        desc.classList.add('is-clamped');
        // read after the clamp is applied and layout has settled
        var overflows = desc.scrollHeight - desc.clientHeight > 1;
        more.hidden = !overflows;
        if (!overflows) desc.classList.remove('is-clamped');
      };
      // run it once now, once after two frames (buybox grid / flex column can
      // still be settling at DOMContentLoaded — this was why it read "fits"
      // on desktop), then again once fonts and all assets have loaded.
      evaluate();
      requestAnimationFrame(function () { requestAnimationFrame(evaluate); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(evaluate).catch(function () {});
      }
      window.addEventListener('load', evaluate);
      // width changes flip whether the copy runs past 3 lines (600px desktop
      // vs ~360px mobile), so re-check on resize too.
      var descTimer;
      window.addEventListener('resize', function () {
        clearTimeout(descTimer);
        descTimer = setTimeout(evaluate, 200);
      });
      more.addEventListener('click', function (e) {
        e.preventDefault();
        var expanded = desc.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        more.textContent = expanded
          ? more.getAttribute('data-label-less')
          : more.getAttribute('data-label-more');
      });
    }

    var sizeBtn = document.querySelector('[data-ha-size-chart]');
    if (sizeBtn) {
      sizeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var root = document.querySelector('[data-ha-product]');
        var trigger =
          (root && root.querySelector('.product-form--root .modal--link')) ||
          document.querySelector('[data-size-chart-enabled="true"] .modal--link');
        if (trigger) trigger.click();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollection();
    initCarousel();
    initProductUi();
    initCardVideos(document);
  });
})();
